import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { hasCapability, useSession } from '../session/session';

/**
 * Exports the list as CSV with the filters now applied (FRD-CORE-040): a plain link, so the browser
 * downloads the file; the API checks the `export` permission, masks designated fields and records
 * the export in the audit trail. Shown only to a session holding the permission. A scoped export
 * grant exports its scope only: the API narrows the rows to what the user may both view and export.
 */
export function ExportButton({
  recordType,
  href,
  label = 'Export CSV',
}: {
  recordType: string;
  href: string;
  label?: string;
}) {
  const session = useSession();
  const capability = `${recordType}:export`;
  if (!hasCapability(session.data, capability)) return null;
  return (
    <Button component="a" href={href} variant="outlined" startIcon={<FileDownloadIcon />}>
      {label}
    </Button>
  );
}
